import { BenefitType } from "./enums/benefit-type.enum";

export class PlanSelection {
  RateTablePackagePlan: RateTablePackage[];
}

export class RateTablePackage {
  PackageId: number;
  OrionPackageId: string;
  CoverageTypeId: number;
  PackageName: string;
  MinPlanAllowed: number;
  MaxPlansAllowed: number;
  Networks: Network[];
  IsSelectBoxActive: boolean = false;
  PlanSelected: number = 0;
}
export class Network {
  NetworkId: number;
  NetworkName: string;
  Plans: Plan[];
  BenefitTypeId: BenefitType;
  IsSelectBoxActive: boolean = false;
  ShowNetworkInAllPlans: boolean = false;
  NetworkOrder: number;
  PackageId: number;
}
export class Plan {
  PlanId: number;
  PlanName: string;
  PlanRates: PlanRates[];
  IsSelectBoxActive: boolean = false;
  AreaName: string;
  PlanNetworkName: string;
}
export class PlanRates {
  Rates: string[];
}
export class EmployeeContribution {
  EmployerContributionTypeId: number;
  PayPeriod: number;
  EmployeeContributionPercent: number;
  DependentContributionPercent: number;
  EmployerSelectedPlanId: number;
  EmployerSelectedPlan: string;
  ContributionAmountTypeId: number;
  EmployeeContributionAmount: number;
  DependentContributionAmount: number;
}
